export default __webpack_public_path__ + "static/media/hero-image.c7d3c472.png";